import { Box, Typography } from "@mui/material";
import React from "react";

/**
 * This component is used to display an empty state message.
 * @param {Object} props Component props.
 * @param {string} props.title The title to display.
 * @param {string} props.subtitle The subtitle to display.
 * @returns {ReactElement} The rendered component.
 */
export const EmptyState = ({ title = "", subtitle = "", fullHeight = false }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 2,
        borderRadius: 2,
        backgroundColor: "#F9F6FF",
        border: "1px dashed #C7B8EA",
        color: "#7E57C2",
        flex: fullHeight ? 1 : "unset",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          color: "#674BF5",
        }}
      >
        {title}
      </Typography>
      <Typography variant="caption" sx={{ textAlign: "center" }}>
        {subtitle}
      </Typography>
    </Box>
  );
};
